import React from "react";
import { Link } from "react-router-dom";
import { Hourglass } from "@phosphor-icons/react";

export default function PendingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#050505] text-white p-8">
      <div className="max-w-md text-center fade-up">
        <div className="w-16 h-16 rounded-sm bg-[#FACC15]/15 border border-[#FACC15]/40 flex items-center justify-center mx-auto mb-6">
          <Hourglass size={32} color="#FACC15" weight="duotone" />
        </div>
        <h1 className="font-display text-3xl mb-3">Pendiente de aprobación</h1>
        <p className="text-white/60 text-sm mb-6">
          Tu cuenta está en revisión. Un administrador debe aprobarla antes de que puedas ingresar.
        </p>
        <Link
          to="/login"
          className="inline-block px-5 py-2.5 rounded-sm bg-[#0055FF] text-sm font-semibold hover:brightness-110 transition-transform active:scale-[0.98]"
        >
          Volver al inicio
        </Link>
      </div>
    </div>
  );
}
